// import { mapRootGetter, mapRootState } from './utils';
import { shortRootState, shortRootGetter } from '../utils/vuex'

export default {
  // account
  myInfo: shortRootState('account/info'),
  myUid: shortRootGetter('account/uid'),
  myNick: shortRootGetter('account/nick'),
  myLogo: shortRootGetter('account/logo'),
  isValidUser: shortRootGetter('account/isValid'),
  isTeacher: shortRootGetter('account/isTeacher'),
  isRealName: shortRootGetter('account/isRealName'),

  // time
  now: shortRootGetter('timer/now'),
  isAfter: shortRootGetter('timer/isAfter'),
  isBefore: shortRootGetter('timer/isBefore'),
  isBetween: shortRootGetter('timer/isBetween'),
  leftFor: shortRootGetter('timer/leftFor'),
  leftSecs: shortRootGetter('timer/leftSecs')

  // config
  // cupType: shortRootState('config/cupType', 1),
  // playConfig: shortRootState('config/play', null),
  // playLineNum: shortRootGetter('config/playLineNum', 80),
  // playMode: shortRootGetter('config/playMode', 1),
}
